import { Injectable } from '@angular/core';
import { OrderMenuItemPinningStore } from 'stores/order-menu-item-pinning.store';
import { Location2Store } from 'stores/location2.store';
import { StorageService } from 'services/storage.service';
import { RxUtil } from 'utility/rx.util';

@Injectable({
  providedIn: 'root'
})
export class OrderMenuItemPinningService {
  constructor(
    private orderMenuItemPinningStore: OrderMenuItemPinningStore,
    private location2Store: Location2Store,
    private storageService: StorageService
  ) {}

  async loadPinnedItemsForCurrentLocation() {
    this.orderMenuItemPinningStore.setPinnedMenuItemIds(
      this.storageService.get<string[]>(
        await this.buildPinnedItemsStorageKey()
      ) ?? []
    );
  }

  async togglePinMenuItem(itemId: string) {
    this.orderMenuItemPinningStore.togglePinMenuItem(itemId);
    await this.syncLocationPinsToStorage();
  }

  async unpinMenuItem(itemId: string) {
    this.orderMenuItemPinningStore.unpinMenuItem(itemId);
    await this.syncLocationPinsToStorage();
  }

  async unpinAllMenuItems() {
    this.orderMenuItemPinningStore.unpinAllMenuItems();
    await this.syncLocationPinsToStorage();
  }

  private async syncLocationPinsToStorage() {
    this.storageService.set(
      await this.buildPinnedItemsStorageKey(),
      await RxUtil.takeOne(this.orderMenuItemPinningStore.pinnedMenuItemIds$)
    );
  }

  private async buildPinnedItemsStorageKey(): Promise<string> {
    return `${
      (await this.location2Store.getCurrentLocation()).id
    }-pinned-menu-items`;
  }
}
